import { MEDIA_TAGS } from '@inspection/constants';

export const getTagColor = (code: string) => {
  if (code === MEDIA_TAGS.GALLERY || code === MEDIA_TAGS.CAMERA) return 'green';
  else return 'blue';
};
